import React, {
  useRef, useState, useMemo, useCallback, useEffect,
} from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { Icons } from '../../../components/base/BootstrapComponents';
import { MAP_CENTER } from '../../../configs';
import { optionClassFormatter } from '../../../utils/formatters';
import { responseLogWithNotification } from '../../../utils/utils';
import CamerasPopup from './CamerasPopup';
import { loadHostDetail } from '../../ParkingMeter/actions';
import { cMetricKeys } from '../constants';

export default function CamerasMap(props) {
  const {
    camerasStatusesList,
    triggerFullScreen = () => {},
    hostDetail,
    selectedHost,
    zoom,
    setZoom,
    setHost,
    isCenter,
    setIsCenter,
  } = props;
  const { clusterByGrid } = window.yandexMap;
  const [showParkingMeter, setShowParkingMeter] = useState(false);
  const leafletContainerRef = useRef(null);
  const [fullScreen, setFullScreenMap] = useState(false);
  const [center, setCenter] = useState(MAP_CENTER);
  const dispatch = useDispatch();
  const loadPosition = () => {
    const map = localStorage.getItem('camera-map');
    return JSON.parse(map) || null;
  };

  const savePosition = (center1, zoom1) => {
    const zoom = zoom1 || window.map.zoom;
    const center = center1 || window.map.center;
    localStorage.setItem('camera-map', JSON.stringify({ center, zoom }));
    setIsCenter(false);
  };
  const onMarkerClick = item => {
    dispatch(loadHostDetail({ id: item.properties.id, metricKeys: cMetricKeys })).then(() => {
      setShowParkingMeter(true);
    }).catch(responseLogWithNotification);
    savePosition(item.geometry.coordinates);
    setHost(null);
  };
  const onClusterClick = (coordinates, features) => {
    // const params = getScale(features.map(f => f.geometry.coordinates), window.map, true, true);
    const newZoom = Math.min(window.map.zoom + 2, window.map.zoomRange.max);
    setZoom(newZoom);
    setCenter(coordinates);
    savePosition(coordinates, newZoom);
  };

  const marker = useCallback(
    feature => (
      <YMapMarker coordinates={feature.geometry.coordinates} source="my-source">
        <Icons icon="parking-meter-marker" customIcon className={classNames('map-marker', optionClassFormatter(feature.properties.status))} onClick={() => { onMarkerClick(feature); }} />
      </YMapMarker>
    ),
    [],
  );
  const cluster = useCallback(
    (coordinates, features) => {
      const sorted = features.sort((a, b) => {
        if (a.properties.status < b.properties.status) {
          return -1;
        }
        if (a.properties.status > b.properties.status) {
          return 1;
        }
        return 0;
      });
      return (
        <YMapMarker coordinates={coordinates} source="my-source">
          <div className={classNames('parking-meter-marker-cluster', optionClassFormatter(sorted[0].properties.status))} onClick={() => { onClusterClick(coordinates, features); }}>
            <div className="parking-meter-marker-count">{features.length <= 99 ? features.length : '99+' }</div>
          </div>
        </YMapMarker>
      );
    },
    [],
  );
  const gridSizedMethod = useMemo(() => clusterByGrid({ gridSize: 32 }), []);

  const toggleFullScreenMap = value => {
    setFullScreenMap(value);
    triggerFullScreen(value);
  };

  const {
    YMap,
    YMapDefaultSchemeLayer,
    YMapControls,
    YMapZoomControl,
    YMapControlButton,
    YMapDefaultFeaturesLayer,
    YMapMarker,
    YMapDefaultMarker,
    YMapClusterer,
    YMapFeatureDataSource,
    YMapLayer,
    YMapListener,
  } = window.yandexMap;

  const LOCATION = !selectedHost ? (loadPosition() ? loadPosition() : { center, zoom }) : { center: [selectedHost.zbx_location_lon, selectedHost.zbx_location_lat], zoom: 14 };

  const points = camerasStatusesList
    .map(p => {
      p.coordinates = [];
      // p.coordinates = [30 + Math.random(), 59 + Math.random()];
      if (Number(p.zbx_location_lat) && Number(p.zbx_location_lon)) {
        p.coordinates = [p.zbx_location_lon, p.zbx_location_lat];
      }
      // p.status = 1;
      return p;
    })
    .filter(p => p.coordinates.length)
    .map((p, i) => ({
      type: 'Feature',
      id: i,
      geometry: { coordinates: p.coordinates },
      properties: p,
    }));

  useEffect(() => {
    if (isCenter) {
      setZoom(12);
      setCenter(MAP_CENTER);
      savePosition(MAP_CENTER, 12);
    }
  }, [isCenter]);

  return (
    <div className="frame map-frame position-relative g-0">
      <div className={classNames('map-container', { 'full-screen': fullScreen })} ref={leafletContainerRef}>
        <YMap location={LOCATION} ref={x => { window.map = x; }}>
          <YMapListener onStateChanged={() => { savePosition(); }} />
          <YMapDefaultSchemeLayer />
          <YMapDefaultFeaturesLayer />
          <YMapControls position="right">
            <YMapControlButton onClick={() => toggleFullScreenMap(!fullScreen)}>
              <Icons customIcon icon={fullScreen ? 'fullscreen-exit' : 'fullscreen'} className="fullscreen-icon" />
            </YMapControlButton>
            <YMapControlButton onClick={() => setIsCenter(true)}>
              <Icons customIcon icon="center-map" className="center-icon" />
            </YMapControlButton>
            <YMapZoomControl />
          </YMapControls>
          <YMapFeatureDataSource id="my-source" />
          <YMapLayer source="my-source" type="markers" zIndex={1800} />
          <YMapClusterer
            marker={marker}
            cluster={cluster}
            method={gridSizedMethod}
            features={points}
          />
        </YMap>
      </div>
      {showParkingMeter ? <CamerasPopup item={hostDetail} handleClose={() => setShowParkingMeter(false)} /> : null}
    </div>
  );
}
